export const mainNavigation = [
  { label: "Soins", to: "/#soins" },
  { label: "Le cabinet", to: "/cabinet" },
  { label: "Thérapeutes", to: "/therapeutes" },
  { label: "Kinétips", to: "/kinetips" },
  { label: "Contact", to: "/#contact" },
];

export const pendingPages = [
  {
    path: "/cabinet",
    title: "Le cabinet",
    description:
      "La présentation du cabinet, de ses équipements et de notre engagement EcoSoignant arrive bientôt.",
  },
  {
    path: "/therapeutes",
    title: "Thérapeutes",
    description:
      "Les profils de nos kinésithérapeutes, ostéopathe, orthophoniste et psychomotricien seront publiés prochainement.",
  },
  {
    path: "/kinetips",
    title: "Kinétips",
    description:
      "Nos conseils pour mieux comprendre votre corps au quotidien seront bientôt disponibles ici.",
  },
  {
    path: "/mentions-legales",
    title: "Mentions légales",
    description: "Cette page est en cours de rédaction.",
  },
];
